// * update the search bar later
import React, { useState } from 'react';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import './TopNav.css';
import './HomeCard.css';
import watchMe from '../assets/watchMe.PNG'; 

const TopNav = () => {
  // State to manage the search query input
  const [searchQuery, setSearchQuery] = useState('');
  // useNavigate hook for programmatic navigation
  const navigate = useNavigate();

  // Handle form submission for search
  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      // Navigate to the search results page with the search query
      navigate(`/search/${searchQuery}`);
      // Clear the search input after navigating
      setSearchQuery('');
    }
  };

  return (
    <nav className="top-nav">
      {/* Logo section */}
      <div className="Logos">
        <Link to="/">
          <img src={watchMe} alt="myLogo" className='logo' />
        </Link>
      </div>

      {/* Navigation and search section */}
      <div className="left-section">
        {/* SearchBar form */}
        <form className="search-bar" onSubmit={handleSearch}>
          <input
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </form>
        
   <span className='nav-links'>
          {/* Links to other pages */}
          <NavLink to="/recent" className='nav-linking' activeClassName="current">Recent</NavLink>
          <NavLink to="/popular" className='nav-linking' activeClassName="current">Popular</NavLink>
          {/* External link to documentation */}
          <a href="https://github.com/Gozkybrain/v2-watcheMe" className='nav-linking' target="_blank" rel="noopener noreferrer">Documentation</a>
      
   </span>  </div>
    </nav>
  );
};

export default TopNav;
